import { ClientAccountInformation } from '@lune-fe/dapi-models'
import { formatNumbers, LuneThemeNew, TableNew, Text } from '@lune-fe/lune-ui-lib'
import { Link } from '@mui/material'
import { Big } from 'big.js'
import { FC } from 'react'

import AccountNameAndLogoTile from 'components/AccontNameAndLogoTile'
import EmptyStatePlaceholder from 'components/EmptyStatePlaceholder'
import ClientAccountsIllustration from 'images/client-accounts.png'
import ClientAccountsContextMenu from 'views/Homepage/ClientAccountsContextMenu'

const { palette } = LuneThemeNew

const ClientAccountsTable: FC<{
    accounts: ClientAccountInformation['topActiveClientAccounts']
}> = ({ accounts }) => {
    if (accounts.length === 0) {
        return (
            <EmptyStatePlaceholder
                illustration={ClientAccountsIllustration}
                title={'You haven’t created any client accounts yet.'}
                extra={
                    <Link
                        sx={{
                            color: palette.TextPrimary,
                            textDecorationColor: palette.TextPrimary,
                            mt: -3,
                            '.MuiTypography-root': {
                                fontWeight: 'normal',
                            },
                        }}
                        target={'_blank'}
                        href={'https://docs.lune.co/general-concepts/accounts'}
                    >
                        <Text variant={'body3-medium'}>
                            Learn how to create and use client accounts via the Lune API
                        </Text>
                    </Link>
                }
            />
        )
    }

    return (
        <TableNew.TableContainer>
            <TableNew
                stickyHeader
                headerCells={
                    <TableNew.TableRow>
                        <TableNew.TableCell colSize={5}>Account</TableNew.TableCell>
                        <TableNew.TableCell colSize={3} alignEnd>
                            Calculations
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={3} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </TableNew.TableRow>
                }
                bodyCells={
                    <>
                        {accounts.map((account, i: number) => {
                            return (
                                <TableNew.TableRow
                                    key={i}
                                    sx={{
                                        '&:hover': {
                                            '.MuiButtonBase-root': {
                                                opacity: 1,
                                            },
                                        },
                                    }}
                                >
                                    <TableNew.TableCell colSize={5} compact>
                                        <AccountNameAndLogoTile
                                            logo={account.logo}
                                            accountName={account.name}
                                        />
                                    </TableNew.TableCell>
                                    <TableNew.TableCell colSize={3} alignEnd compact>
                                        {formatNumbers(account.totalNumberOfCalculations, 2)}
                                    </TableNew.TableCell>
                                    <TableNew.TableCell colSize={3} alignEnd compact>
                                        {Big(account.quantity).lt(1)
                                            ? formatNumbers(account.quantity, 6)
                                            : formatNumbers(account.quantity, 2)}
                                    </TableNew.TableCell>
                                    <TableNew.TableCell
                                        compact
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                        }}
                                        alignEnd
                                        colSize={1}
                                        sx={{
                                            '.MuiButton-root': {
                                                opacity: 0,
                                            },
                                            '&:hover': {
                                                '.MuiButton-root': {
                                                    opacity: 1,
                                                },
                                            },
                                        }}
                                    >
                                        <ClientAccountsContextMenu accountId={account.id} />
                                    </TableNew.TableCell>
                                </TableNew.TableRow>
                            )
                        })}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default ClientAccountsTable
